import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatChipSelectionChange } from '@angular/material/chips';

@Component({
  selector: 'gymfinder-options-chips',
  templateUrl: './chips.component.html',
  styleUrls: ['./chips.component.scss'],
  standalone: false,
})
export class OptionsChipsComponent {
  @Input()
  name: string;

  @Input()
  editMode: boolean;

  @Input()
  selectedChips: string[] | undefined;

  @Input()
  allChips: string[] | undefined;

  @Input()
  disabledChips: string[] | undefined;

  @Input()
  getTranslation: (key: string) => string;

  @Output()
  chipsChange = new EventEmitter<string[]>();

  get sortedChips(): string[] | undefined {
    if (!this.allChips) {
      return undefined;
    }
    return [...this.allChips].sort((a, b) => {
      const translationA = this.getTranslation(a).toLowerCase();
      const translationB = this.getTranslation(b).toLowerCase();
      return translationA.localeCompare(translationB);
    });
  }

  handleSelectionChange = (chip: string, value: MatChipSelectionChange) => {
    // When Selection is made using the keyboard (with the SPACE key), value.isUserInput is true
    if (value.isUserInput) {
      this.updateChips(chip);
    }
  };

  handleClick = (chip: string) => this.updateChips(chip);

  shouldBeDisabledFor = (chip: string) =>
    !this.editMode || this.isADisabledChip(chip);

  private updateChips = (chip: string) => {
    if (!this.isADisabledChip(chip)) {
      if (this.selectedChips?.includes(chip)) {
        this.selectedChips = this.selectedChips.filter(o => o !== chip);
      } else {
        this.selectedChips = this.selectedChips
          ? [...this.selectedChips, chip]
          : [chip];
      }
      this.chipsChange.emit(this.selectedChips);
    }
  };

  private isADisabledChip = (chip: string) =>
    this.disabledChips?.includes(chip);
}
